<template>
    <div class="d-flex justify-content-end align-items-end flex-column">
        <small class="text-bold text-muted mb-2" v-if="timeToComplete">{{timeToComplete}}</small>
        <b-button
            variant="secondary"
            class="align-self-end px-3"
            size="sm"
            @click="$emit('onCta')"
        >
            {{ trans('courses.new_dashboard.start_now') }}
        </b-button>
    </div>
</template>

<script>
export default {
    name: "MiuCardContent",
    props:{
        timeToComplete: String
    }
}
</script>
